import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { createAuthAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import ClientManagement from '../components/admin/ClientManagement';
import ExerciseManagement from '../components/admin/ExerciseManagement';
import RecipeManagement from '../components/admin/RecipeManagement';
import { LogOut, Users, Dumbbell, ChefHat } from 'lucide-react';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [activeTab, setActiveTab] = useState('clients');

  const handleLogout = () => {
    logout();
    navigate('/');
    toast.success('Sesión cerrada');
  };

  return (
    <div className="min-h-screen pharmacy-gradient">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-green-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <div className="flex justify-between items-center gap-4">
            <div className="flex items-center space-x-3 min-w-0 flex-1">
              <img src="/logo.jpg" alt="Farmacia Tarin" className="h-12 w-auto flex-shrink-0" />
              <div className="min-w-0">
                <h1 className="text-xl font-bold text-green-800 truncate">Panel de Administración</h1>
                <p className="text-xs text-gray-600">Farmacia Tarin</p>
              </div>
            </div>
            <Button 
              onClick={handleLogout} 
              variant="outline" 
              size="sm"
              className="flex items-center gap-1 flex-shrink-0"
              data-testid="logout-button"
            >
              <LogOut className="h-3 w-3" />
              <span className="hidden sm:inline">Cerrar Sesión</span>
              <span className="sm:hidden">Salir</span>
            </Button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="grid w-full grid-cols-3 bg-white/50 backdrop-blur p-1 rounded-xl">
            <TabsTrigger 
              value="clients" 
              className="flex items-center gap-2 data-[state=active]:bg-green-600 data-[state=active]:text-white"
              data-testid="clients-tab"
            >
              <Users className="h-4 w-4" />
              Clientes
            </TabsTrigger>
            <TabsTrigger 
              value="exercises"
              className="flex items-center gap-2 data-[state=active]:bg-green-600 data-[state=active]:text-white"
              data-testid="exercises-tab"
            >
              <Dumbbell className="h-4 w-4" />
              Ejercicios
            </TabsTrigger>
            <TabsTrigger 
              value="recipes"
              className="flex items-center gap-2 data-[state=active]:bg-green-600 data-[state=active]:text-white"
              data-testid="recipes-tab"
            >
              <ChefHat className="h-4 w-4" />
              Recetas
            </TabsTrigger>
          </TabsList>

          <TabsContent value="clients" className="space-y-4">
            <ClientManagement />
          </TabsContent>

          <TabsContent value="exercises" className="space-y-4">
            <ExerciseManagement />
          </TabsContent>

          <TabsContent value="recipes" className="space-y-4">
            <RecipeManagement />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default AdminDashboard;